import React, { useEffect, useState } from "react";
import { DefaultDropdown } from "../../../../_helpers/components/Forms/Dropdown";
import { Button } from "../../../../_helpers/components/Button";
import { Toggle } from "../../../../_helpers/components/Forms/ToggleButton";
import { getRightsProfile, attachRightsProfile } from "../../../../_api/RightsManagement";
import { editUserInfos, getUsers, addValidator, deleteValidator } from "../../../../_api/Admin";
import { Search } from "../../../../Layout/Private/Search";
import { Table } from "../../../../_helpers/Table";
import toast from "react-hot-toast";
import { useOutletContext } from "react-router-dom";
import { editPassword } from "../../../../_api/User";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";

const ParametresTab = (props) => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFOS"]["features"];

    const { profile, refreshProfil } = props;

    const [profileRight, setProfileRight] = useState(profile?.policy?.id);
    const [profileRights, setProfileRights] = useState([]);
    const [isActivated, setIsActicated] = useState(profile?.activated ?? false);
    const [isWorkingOnOpenHoliday, setIsWorkingOnOpenHoliday] = useState(profile?.is_working_on_open_holiday ?? false);
    const [useTimeTracking, setUseTimeTracking] = useState(profile?.use_time_tracking ?? false);

    // Section Validateurs
    const [validators, setValidators] = useState([]);
    const [users, setUsers] = useState([]);
    // Section Mot de passe
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [isSavingPassword, setIsSavingPassword] = useState(false);

    useEffect(() => {
        if (profile) {
            setValidators(
                profile.validators?.map((validator) => {
                    return {
                        row: [
                            validator.first_name,
                            validator.last_name,
                            <button
                                key={validator.id}
                                onClick={() => deleteValidatorSelected(validator)}
                                className="text-red-600 hover:text-red-800 transition-colors"
                                title="Supprimer le validateur"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="h-4 w-4"
                                    style={{ transform: "none" }}
                                    aria-hidden="true"
                                >
                                    <path d="M3 6h18" />
                                    <path d="M8 6V4h8v2" />
                                    <path d="M19 6l-1 14H6L5 6" />
                                    <path d="M10 11v6" />
                                    <path d="M14 11v6" />
                                </svg>
                            </button>,
                        ],
                        data: validator,
                    };
                }) || []
            );

            getUsers().then((resp) => {
                const content = Array.isArray(resp.data)
                    ? resp.data
                    : resp.data[0];

                setUsers(
                    content.map((user) => {
                        return {
                            value: user.id,
                            label: `${user.last_name} ${user.first_name}`,
                        };
                    })
                );
            });
        }
    }, [profile]);

    const deleteValidatorSelected = (validator) => {
        deleteValidator(profile.id, validator.id).then((resp) => {
            toast.success("Validateur supprimé");
            refreshProfil();
        }).catch((error) => {
            toast.error("Erreur lors de la suppression");
        });
    };

    const createValidator = (item) => {
        addValidator(profile.id, item.value).then((resp) => {
            toast.success("Validateur ajouté");
            refreshProfil();
        }).catch((error) => {
            toast.error("Erreur lors de l'ajout");
        });
    };

    useEffect(() => {
        getRightsProfile().then((resp) => {
            setProfileRights(
                resp.data.map((res) => {
                    return { value: res.id, label: res.name };
                })
            );

            if (profile?.policy) {
                setProfileRight(profile.policy.id);
            } else {
                if (resp.data.length > 0) {
                    setProfileRight(resp.data[0].id);
                }
            }
        });
    }, [profile]);

    const handleSave = () => {
        const payload = {
            profileRight: profileRight,
            is_working_on_open_holiday: isWorkingOnOpenHoliday,
            activated: isActivated,
            use_time_tracking: useTimeTracking,
        };

        setIsSaving(true);
        editUserInfos(payload, profile.id)
            .then((resp) => {
                attachRightsProfile(profileRight, {
                    user_id: profile.id,
                }).then((resp) => {

                });
                toast.success("Les paramètres ont été modifiés.");
                refreshProfil();
            })
            .catch((error) => {
                toast.error("Erreur lors de la modification");
            })
            .finally(() => {
                setIsSaving(false);
            });
    };


    const handleSavePassword = () => {
        if (password !== password2) {
            toast.error("Attention : les deux mots de passe sont différents.");
            return;
        }

        if (password.length < 8) {
            toast.error("Attention : le mot de passe doit contenir au moins 8 caractères.");
            return;
        }

        setIsSavingPassword(true);
        editPassword({ password }, profile.id).then((resp) => {
            toast.success("Le mot de passe a été modifié.");
            setPassword("");
            setPassword2("");
        }).catch((error) => {
            toast.error("Erreur lors de la modification");
        }).finally(() => {
            setIsSavingPassword(false);
        });
    };
    return (
        <div className="space-y-6">
            {/* Section Paramètres */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="flex items-center mb-6">
                    <div className="flex items-center justify-center w-10 h-10 bg-orange-100 rounded-lg mr-3">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-orange-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                        Paramètres du compte
                    </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div>
                        <DefaultDropdown
                            options={profileRights}
                            name="Profil d'autorisation"
                            value={profileRight}
                            onChange={(e) => setProfileRight(e.target.value)}
                        />
                    </div>
                    <div>
                        <Toggle
                            enabled={isWorkingOnOpenHoliday}
                            setEnabled={() =>
                                setIsWorkingOnOpenHoliday(!isWorkingOnOpenHoliday)
                            }
                            name="Travaille les jours fériés"
                        />
                    </div>
                    <div>
                        <Toggle
                            enabled={useTimeTracking}
                            setEnabled={() => setUseTimeTracking(!useTimeTracking)}
                            name="Utiliser le suivi de temps (pointage)"
                        />
                    </div>
                    <div>
                        <Toggle
                            enabled={isActivated}
                            setEnabled={() => setIsActicated(!isActivated)}
                            name="Compte actif"
                        />
                    </div>
                </div>
                {/* Bouton de sauvegarde */}
                <div className="flex justify-end pt-4">
                    <Button
                        action={handleSave}
                        isVisible={features_right["edit_user"]}
                        loading={isSaving}
                        name={
                            <span className="flex items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 mr-2"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                Enregistrer les paramètres
                            </span>
                        }
                        type={"empty"}
                    />
                </div>
            </div>

            {/* Section Validateurs */}
            {profile && (
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                    <div className="flex items-center justify-between mb-6">
                        <div className="flex items-center">
                            <div className="flex items-center justify-center w-10 h-10 bg-teal-100 rounded-lg mr-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-teal-600"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                                    />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900">
                                Validateurs
                            </h3>
                        </div>
                        {features_right["validator_management"] && (
                            <div className="w-64">
                                <Search
                                    id="validator-search"
                                    items={users}
                                    handleClick={createValidator}
                                    placeholder="Rechercher un validateur"
                                />
                            </div>
                        )}
                    </div>
                    {validators && validators.length > 0 ? (
                        <Table
                            headers={["Prénom", "Nom", "Action"]}
                            rows={validators}
                            hideTitle={true}
                        />
                    ) : (
                        <div className="text-center py-6 text-gray-500">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-10 w-10 mx-auto mb-2 text-gray-400"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                                />
                            </svg>
                            <p className="text-sm">Aucun validateur</p>
                            {features_right["validator_management"] && (
                                <p className="text-xs text-gray-400 mt-1">
                                    Utilisez la recherche ci-dessus pour en ajouter
                                </p>
                            )}
                        </div>
                    )}
                </div>
            )}

            {/* Section Mot de passe */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                        <div className="flex items-center justify-center w-10 h-10 bg-yellow-100 rounded-lg mr-3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-yellow-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"
                                />
                            </svg>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900">
                            Mot de passe
                        </h3>
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 flex-wrap">
                    <div>
                        <InputForm
                            id="new-password"
                            type="password"
                            name="Nouveau mot de passe"
                            placeholder="Nouveau mot de passe"
                            value={password}
                            set={setPassword}
                            autoComplete="new-password"
                        />
                    </div>
                    <div>
                        <InputForm
                            id="confirm-password"
                            type="password"
                            name="Confirmation"
                            placeholder="Confirmation du mot de passe"
                            value={password2}
                            set={setPassword2}
                            autoComplete="new-password"
                        />
                    </div>
                    <div className="lg:mt-5">
                        <Button
                            action={handleSavePassword}
                            name="Modifier"
                            type="empty"
                            loading={isSavingPassword}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ParametresTab;

